module.exports = __webpack_public_path__ + "img/w70b.14d00470.jpg";